/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.9398 9.3913c2.5798 0 4.6711-2.1023 4.6711-4.6956C16.6109 2.1022 14.5196 0 11.9398 0S7.2687 2.1023 7.2687 4.6956c0 2.5934 2.0913 4.6957 4.6711 4.6957Zm0-1.5652c1.7198 0 3.1141-1.4016 3.1141-3.1305 0-1.7288-1.3943-3.1304-3.1141-3.1304-1.7199 0-3.1141 1.4016-3.1141 3.1304 0 1.729 1.3942 3.1305 3.1141 3.1305ZM.1085 6.9017C.557 8.5709 2.2665 9.5585 3.927 9.1075c1.6604-.4508 2.6428-2.1694 2.1943-3.8384C5.6727 3.6 3.9632 2.6124 2.3028 3.0633.6424 3.514-.34 5.2327.1085 6.9017Zm1.5032-.4081c.2242.8345 1.079 1.3283 1.9092 1.1029.8302-.2255 1.3214-1.0847 1.0971-1.9193-.2242-.8345-1.079-1.3283-1.9092-1.1029-.8302.2255-1.3214 1.0847-1.0971 1.9193Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M5.335 10.3465c.1787.6646-.3592.9082-.7986 1.0275-1.3482.3661-2.4126 1.424-2.9426 2.8161-.1588.4172-.595.6857-1.0225.5638-.3956-.1129-.6379-.52-.5047-.9111.6496-1.9081 2.0757-3.44 4.0638-3.9799.2727-.074 1.026-.181 1.2047.4836Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.8915 6.9017c-.4485 1.6691-2.1581 2.6567-3.8184 2.2058-1.6604-.4508-2.6428-2.1694-2.1943-3.8384.4485-1.6691 2.1581-2.6567 3.8184-2.2058 1.6604.4508 2.6428 2.1694 2.1943 3.8384Zm-1.5032-.4081c-.2242.8345-1.079 1.3283-1.9092 1.1029-.8302-.2255-1.3214-1.0847-1.0971-1.9193.2242-.8345 1.079-1.3283 1.9092-1.1029.8302.2255 1.3214 1.0847 1.0971 1.9193Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M18.6649 10.3465c-.1786.6646.3593.9082.7987 1.0275 1.3482.3661 2.4126 1.424 2.9425 2.8161.1589.4172.5952.6857 1.0226.5638.3956-.1129.6379-.52.5047-.9111-.6496-1.9081-2.0757-3.44-4.0638-3.9799-.2727-.074-1.0261-.181-1.2047.4836Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.3201 23.6206S17.6726 24 11.9398 24c-5.7329 0-10.3803-.3794-10.3803-.3794 0-6.706 4.6474-12.1423 10.3803-12.1423 5.7328 0 10.3803 5.4363 10.3803 12.1423ZM4.6779 22.247a135.5638 135.5638 0 0 1-1.4799-.0826c.6025-5.3227 4.4628-9.1209 8.7418-9.1209s8.1393 3.7982 8.7418 9.1209c-.4198.0258-.9172.0542-1.48.0826-1.8599.094-4.428.1878-7.2618.1878s-5.402-.0938-7.2619-.1878Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuGroups'
);
